import { appRoutes } from 'app/app-routes';
import _ from 'lodash';
import InfoPage from 'stories/layout/InfoPage';

const ErrorPage = () => {
  return (
    <InfoPage
      header="Oops..."
      message1="Something went wrong, but the robots are tracking the issue now..."
      actionLabel="Home Page"
      action={appRoutes.home}
    />
  );
};

export default ErrorPage;
